module.exports = __webpack_public_path__ + "static/media/galerija_2019 (11).e2aa274b.jpg";